import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Table, Space, Empty } from 'antd'
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons'
import PageLoader from '../../../components/Layouts/PageLoader'
import PaginationContainer from '../../../components/Forms/Pagination'
import { getRequest, formatUrl, dutyBroadcastsUrl } from '../../../config'
import { broadcastStatusTag } from './statusColors'

// The Broadcasts landing list: every campaign with its status, recipient count, and schedule.
const BroadcastList = props => {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])
  const [meta, setMeta] = useState({ previous: null, next: null, count: 0 })

  const load = async (url = null) => {
    const response = await getRequest(
      url ? formatUrl(url) : dutyBroadcastsUrl,
      'broadcasts',
      setLoading
    )
    if (response.success) {
      setRows(response.data.results || response.data)
      setMeta({ ...response.data })
    }
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line
  }, [])

  const columns = [
    {
      title: 'Name',
      key: 'name',
      render: (_, r) => <Link to={`/settings/broadcasts/${r.id}`}>{r.name}</Link>
    },
    { title: 'Status', key: 'status', render: (_, r) => broadcastStatusTag(r.status) },
    { title: 'Recipients', dataIndex: 'recipientCount', key: 'recipientCount' },
    {
      title: 'Scheduled',
      dataIndex: 'scheduledAt',
      key: 'scheduledAt',
      render: v => (v ? new Date(v).toLocaleString() : '—')
    },
    {
      title: 'Sent',
      dataIndex: 'dispatchFinishedAt',
      key: 'dispatchFinishedAt',
      render: v => (v ? new Date(v).toLocaleString() : '—')
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: v => (v ? new Date(v).toLocaleDateString() : '—')
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, r) => (
        <Space size={8}>
          <Link to={`/settings/broadcasts/${r.id}`}>Open</Link>
          <Link to={`/settings/broadcasts/${r.id}/compose`}>Edit</Link>
          <Link to={`/settings/broadcasts/${r.id}/recipients`}>Recipients</Link>
        </Space>
      )
    }
  ]

  return (
    <PageLoader className="container" loading={loading}>
      <div className="card mb-5rem">
        <div className="card-body">
          <Space
            style={{ width: '100%', justifyContent: 'space-between', marginBottom: 8 }}
            wrap
          >
            <div>
              <h3 style={{ marginBottom: 4 }}>
                Broadcasts {meta && `(${meta.count || rows.length})`}
              </h3>
              <p style={{ color: '#888', margin: 0 }}>
                Compose a WhatsApp message once and send it to a chosen set of existing
                customers, then track delivery and responses.
              </p>
            </div>
            <Space>
              <Button icon={<ReloadOutlined />} onClick={() => load()}>
                Refresh
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => props.history.push('/settings/broadcasts/new')}
              >
                New broadcast
              </Button>
            </Space>
          </Space>

          <Table
            rowKey="id"
            dataSource={rows}
            columns={columns}
            scroll={{ x: 800 }}
            pagination={false}
            locale={{
              emptyText: <Empty description="No broadcasts yet — create your first one" />
            }}
          />
          {rows.length ? (
            <PaginationContainer meta={meta} getData={url => load(url)} />
          ) : null}
        </div>
      </div>
    </PageLoader>
  )
}

BroadcastList.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object
}

export default BroadcastList
